import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from, switchMap } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    req: HttpRequest<any>, 
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Skip intercepting if user is not logged in or it's not an API request
    if (!this.authService.isLoggedIn()) {
      return next.handle(req);
    }

    // Convert the token acquisition to an observable
    return from(this.authService.acquireToken()).pipe(
      switchMap(token => {
        // Clone the request and add the bearer token
        const authReq = req.clone({
          setHeaders: { 
            Authorization: `Bearer ${token}` 
          }
        });
        
        // Pass on the cloned request
        return next.handle(authReq);
      })
    );
  }
}